<template>
  <div>
    <form>
      <div class="t-flex t-flex-row-reverse">
        <p
          class="t-bg-green-200 t-rounded t-px-2 t-py-1 t-font-medium"
          v-if="location.already_added_location">YOU ALREADY HAVE THIS LOCATION IN YOUR LIST
        </p>
      </div>

      <div class="location-form-field">
        <label>Name</label>
        <p>{{ location.name }}</p>
      </div>

      <div class="location-form-field">
        <label>Address</label>
        <p>
          {{
            `${location.address.street_number} ${location.address.street_name}, ${
              location.address.suburb
            }, ${location.address.city} ${location.address.post_code ? location.address.post_code : ''}`
          }}
        </p>
      </div>

      <div class="location-form-field lg:t-w-1/2">
        <label for="customer-code">Customer Code</label>
        <input v-model="form.customerCode" id="customer-code" type="text">
      </div>

      <p
        v-if="errors.has('location-option')"
        class="t-text-red-600 t-font-medium t-text-sm"
      >
        {{ errors.first("location-option") }}
      </p>

      <div class="location-form-option">
        <input
          v-model="form.locationOptions"
          id="pickup"
          name="location-option"
          type="checkbox"
          value="pickup"
          v-validate.continues="'atLeastOneLocationOption'"
        />
        <div>
          <label for="pickup">Pickup</label>
          <p class="t-text-sm t-text-gray-800">
            Use this location for pickups
          </p>
        </div>
      </div>

      <div class="location-form-option">
        <input
          v-model="form.locationOptions"
          id="delivery"
          name="location-option"
          type="checkbox"
          value="delivery"
          v-validate.continues="'atLeastOneLocationOption'"
        />
        <div>
          <label for="delivery">Delivery</label>
          <p class="t-text-sm t-text-gray-800">
            Use this location for deliveries
          </p>
        </div>
      </div>

      <!-- Buttons -->
      <div
        class="t-flex t-justify-between t-mt-4 t-border-t-2 t-border-gray-800 t-pt-4"
      >
        <button
          @click.prevent="$emit('formBackClicked')"
          class="t-text-lg t-font-medium t-bg-gray-600 t-text-white t-py-2 t-px-4 t-rounded-lg"
        >
          Back
        </button>
        <button
          v-if="!location.already_added_location"
          @click.prevent="onSubmitForm"
          :disabled="isSaving"
          class="t-text-lg t-font-medium t-bg-blue-500 t-text-white t-py-2 t-px-4 t-rounded-lg"
        >
          <i v-if="isSaving" class="fa fa-spinner fa-spin" />
          Add
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'AddFreighthubLocationForm',
  description: 'This is the form used when a user wants to add a location that already exists within Freighthub',
  props: {
    location: {
      type: Object,
    },
    locationType: {
      type: String
    }
  },
  emits: ['formBackClicked'],
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      isSaving: false,
      form: {
        customerCode: '',
        locationOptions: []
      }
    }
  },
  created() {
    this.$validator.extend('atLeastOneLocationOption', {
      getMessage: () => 'Please select at least one location option',
      validate: () => this.form.locationOptions.length > 0
    });
  },
  mounted() {
    if (this.locationType) {
      if (this.locationType === 'pickup') {
        this.form.locationOptions.push('pickup');
      } else if (this.locationType === 'delivery') {
        this.form.locationOptions.push('delivery');
      }
    } else {
      this.form.locationOptions.push('delivery');
    }
  },
  methods: {
    async onSubmitForm() {
      let isValid = await this.$validator.validateAll();

      if (!isValid) {
        return;
      }

      this.isSaving = true;

      let data = {
        customer_code: this.form.customerCode,
        pickup: !!this.form.locationOptions.includes('pickup'),
        delivery: !!this.form.locationOptions.includes('delivery'),
      };

      axios
      .post(`/settings/locations/attach/${this.location.id}`, data)
      .then(() => {
        this.$swal({
          title: 'Added Location!',
          type: 'success',
          confirmButtonText: 'Okay',
        });

        let payload = {
          type: this.locationType
        }
        this.$emit('formSubmitted');
        this.$parent.$emit('submitted', payload);
        this.isSaving = false;
      });
    }
  }
}
</script>

<style scoped>

</style>
